import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const LazyDefaultSpaceLogoConfigPage: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-DefaultSpaceLogoConfigContainer" */ '../src/DefaultSpaceLogoConfig/DefaultSpaceLogoConfigPage.tsx'
			)
		).DefaultSpaceLogoConfigPage,
});
